import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { PaywallService } from 'funnel/src/app/services/paywall.service';
import { provideFunnelSampleContentInitializer } from 'shared/src/services/funnel-sample-content.service';
import { PROJECT_NAME, ProjectNames } from 'shared/src/tokens';
import { provideStatsigInitializer } from '../../../funnel/src/app/app.config';
import { FunnelFlowService } from '../../../funnel/src/app/services/funnel-flow.service';
import { QuizRouteReuseStrategy } from '../../../funnel/src/app/services/quiz-route-reuse-strategy';
import { routes } from './app.routes';
import { ReaderFunnelFlowService } from './services/reader-funnel-flow.service';
import { ReaderPaywallService } from './services/reader-paywall.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    {
      provide: PROJECT_NAME,
      useValue: ProjectNames.READER_FUNNEL,
    },
    {
      provide: RouteReuseStrategy,
      useClass: QuizRouteReuseStrategy,
    },
    provideFunnelSampleContentInitializer(),
    provideStatsigInitializer(),
    {
      provide: FunnelFlowService,
      useClass: ReaderFunnelFlowService,
    },
    {
      provide: PaywallService,
      useClass: ReaderPaywallService,
    },
  ],
};
